import axios from 'axios';
import { globalData, globalConf } from "@olmokit/core/data";
import { $, $all, on, forEach, addClass, removeClass } from "@olmokit/dom";
import { activeStepOnclick, updateStepparams, updateStepparamsRetire, getUrlParamGuest } from "components/Checkout";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import gsap from "gsap";
gsap.registerPlugin(ScrollToPlugin);
import "./index.scss";

/**
 * Component: CheckoutShipping
 */
export function CheckoutEmail() {
  console.log("CheckoutEmail mounted.");
  
  const cmsApiUrl = globalConf.cmsApiUrl;
  const locale = globalConf.locale;
  const user = globalData.user;
  const cartid = globalData.cartid;
  const acc = $all(".step");
  const $checkoutAddressesShipping = $('.CheckoutAddresses:shipping');
  const $checkoutAddressesBilling = $('.CheckoutAddresses:billing_shipping');

  const guest = getUrlParamGuest();
  const $container = $('.CheckoutEmail:container')

  console.log('user', user.length);

  if(user.length){
    acc[0].style.display = 'none'
    const email = $('#Email')
    email.style.display = 'none'
  }  
  
  const config = {
    headers: {
        ...(!guest) && {"x-token": user.token},
        ...(guest) && {"x-guest": guest},
        "Content-Type": "application/json"
    }
  };

  const isEmail = (email) => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const $errors = $('.CheckoutEmail:error');
  const $forward = $('#CheckoutEmail:forward');
  on($forward, 'click', (e) => {
    e.preventDefault();

    const $email = $('#validationTextUsername').value;  
    
    if(isEmail($email)){

      removeClass(acc[0], 'active');
      removeClass(acc[0].nextElementSibling, 'activeStep');
      removeClass($container, 'was-validated');

      const data = {
        email: $email,
        'x-guest': guest
      }; 

      axios.post(cmsApiUrl+'/'+locale+'/createguestcustomer', data, config).then((e) => {
        addClass(acc[1].nextElementSibling, 'activeStep');
        activeStepOnclick(1);
        updateStepparams({step: 1});
        removeClass($errors, 'showError');
        
        gsap.to(window, { duration: 0.3, scrollTo: { y: acc[1], offsetY: 90 } });
  
      }).catch(error => {
        console.log(error);
        // addClass(acc[0].nextElementSibling, 'activeStep');
        // addClass($errors, 'showError');
  
      });   
    } else {      
      addClass($container, 'was-validated');
    }

  });   

  //TODO: Validation email process
  const $forwardCheckEmail = $('#CheckoutEmail:forwardEmail');
  on($forwardCheckEmail, 'click', (e) => {
    e.preventDefault();

    const $email = $('#validationTextUsername').value;  
    
    if(isEmail($email)){

      removeClass(acc[0], 'active');
      removeClass(acc[0].nextElementSibling, 'activeStep');
      removeClass($container, 'was-validated');

      const data = {
        email: $email,
        'x-guest': guest
      }; 

      axios.post(cmsApiUrl+'/'+locale+'/createguestcustomeremail', data, config).then((e) => {
  
      }).catch(error => {
        console.log(error);
        // addClass(acc[0].nextElementSibling, 'activeStep');
        // addClass($errors, 'showError');
  
      });   
    } else {      
      addClass($container, 'was-validated');
    }

  });    

}
